import { Fetch } from '../utils'
import { ApiEndpoints } from '../constants'
import type { Account, Category, GlobalErrorHandler } from '..'

export class CategoryApi {
  fetchInstance: Fetch

  constructor(endpoint: string, token: string, onError?: GlobalErrorHandler) {
    this.fetchInstance = new Fetch(endpoint, token, undefined, onError)
  }

  addCategory = async (category: Category) => {
    return this.fetchInstance.post(ApiEndpoints.CATEGORIES, category).then((data) => data.category)
  }

  getCategories = async () => {
    return this.fetchInstance.get(ApiEndpoints.CATEGORIES).then((data) => data.categories)
  }

  getDateRangeCategoryTotals = async (startDate: number, endDate: number, accounts: Account[]) => {
    // If no accounts are selected, return an empty array
    if (accounts.length === 0) return []
    return this.fetchInstance
      .post(`${ApiEndpoints.DATE_RANGE_CATEGORY_TOTALS}/from/${startDate}/to/${endDate}`, {
        account_guid: accounts.map((account) => account.guid),
      })
      .then((data) => data.date_range_category_totals)
  }

  getMonthlyCategoryTotals = async (startDate: number, endDate: number, accounts?: Account[]) => {
    try {
      const url = `${ApiEndpoints.MONTHLY_CATEGORY_TOTALS}/from/${startDate}/to/${endDate}`
      if (accounts) {
        const accountGuids = accounts.length === 0 ? [''] : accounts.map((account) => account.guid)
        const response = await this.fetchInstance.post(url, { account_guid: accountGuids })
        return response.monthly_category_totals
      } else {
        const response = await this.fetchInstance.get(url)
        return response.monthly_category_totals
      }
    } catch (error) {
      console.error('Error fetching monthly category totals:', error)
      throw error // Re-throw the error for the caller to handle
    }
  }
  removeCategory = async (guid: string) => {
    return this.fetchInstance.delete(`${ApiEndpoints.CATEGORIES}/${guid}`)
  }

  updateCategory = async (category: Category) => {
    return this.fetchInstance
      .put(`${ApiEndpoints.CATEGORIES}/${category.guid}`, category)
      .then((data) => data.category)
  }
}
